module.exports = __webpack_public_path__ + "static/banner-04@2x-65d5f895c87f5bb01e4d077ca904e5e2.png";